import { Link } from "react-router-dom";
import { ArrowLeft, Warning } from "@phosphor-icons/react";

// Structure-only legal document. NOT the final published version: it intentionally
// contains no company name, registration number, address, domain or jurisdiction —
// those are filled in only from verified owner-supplied details before publishing.
// Internal review markers stay in source for tracking but are never shown publicly.
const clean = (t) => (typeof t === "string" ? t.replace(/\s*\[(NEEDS OWNER INPUT|LEGAL REVIEW)[^\]]*\]/g, "") : t);

export default function LegalDoc({ title, updated, intro, sections, testid, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <main className="mx-auto max-w-3xl px-6 py-14" data-testid={testid}>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6"><ArrowLeft /> Back</Link>

        <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2.5 mb-6" data-testid="legal-draft-banner">
          <Warning weight="fill" className="text-amber-600 mt-0.5 shrink-0" />
          <p className="text-xs text-amber-800 leading-relaxed">
            <span className="font-semibold">Draft — not the final published version.</span> Company, registration and jurisdiction details are pending and will be added before public launch.
          </p>
        </div>

        <h1 className="font-heading font-black tracking-tight text-3xl sm:text-4xl">{title}</h1>
        {updated && <p className="mt-2 text-xs text-slate-400">Draft prepared {updated}</p>}
        {intro && <p className="mt-5 text-slate-600 leading-relaxed">{clean(intro)}</p>}

        <div className="mt-8 space-y-7">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading font-bold text-lg text-slate-900">{s.h}</h2>
              {s.p && <p className="mt-2 text-slate-600 leading-relaxed">{clean(s.p)}</p>}
              {s.list && (
                <ul className="mt-2 space-y-1.5 text-slate-600 list-disc pl-5">
                  {s.list.map((li, k) => <li key={k}>{clean(li)}</li>)}
                </ul>
              )}
            </section>
          ))}
        </div>
        {children}
      </main>
    </div>
  );
}
